import React, { Component } from 'react';

//<div>A percentage of your purchase is immediately contributed to helping people in need through our community partners when using our app.</div>
//<div>No extra money is required as contribution. Purchase (+ tip) as usual.</div>

//<div>Improve the lives of people around the world by mobilizing the able to help those in need.</div>

//<div>Platform for Meal-generated Transparent Donations - Create an Account, It's Free</div>

//<div>Platform for Meal-generated Transparent Donations - Join the wish list, Request a demo, Meet your needs. Start today.</div>

//<div>Platform for Meal-generated Transparent Donations - Join the wish list, Access a demo, Meet your needs. Start today.</div>

//<div>Join the wish list, Access a demo, Meet your needs. Start today.</div>

//<div>Get a free e-voucher, Access a demo, Meet your needs. Start today.</div>

//<div>e-Voucher Discount Code, Demo, Stock up wishes. Join others today.</div>

//<div>Receive 1. e-Voucher Discount Code 2. Demo 3. Stock up wishes.</div>

class FollowingHeader extends Component {
  render() {
    return (
      <h3 id="FollowingHeader">
        <div>1. e-Voucher Discount Code 2. Order 3. Stock up wishes.</div>
      </h3>
    );
  }
}

export default FollowingHeader;